import { forwardRef } from 'react';

import MuiStep, { StepProps as MuiStepProps } from '@mui/material/Step';

import { styled } from '@mui/material/styles';
import { shouldForwardProp as sysShouldForwardProp } from '@mui/system';

import { linkClasses } from '../Link';

import { stepIconClasses } from '../StepIcon';
import { BaseColorList } from '../theme/colorList';

export * from '@mui/material/Step';

export interface StepProps extends MuiStepProps {
  color?: BaseColorList;
}

const StyledMuiStep = styled(MuiStep, {
  shouldForwardProp: (prop) => sysShouldForwardProp(prop) && prop !== 'color',
})<StepProps>(({ color, theme }) => ({
  [`& .${stepIconClasses.root}`]: {
    [`&.${stepIconClasses.active}`]: {
      color: theme.palette.common.white,
    },
    [`&.${stepIconClasses.completed}`]: {
      color: theme.palette.primary.main,
    },
  },
  ...(color === 'internal' && {
    [`& .${stepIconClasses.root}`]: {
      [`&.${stepIconClasses.active}`]: {
        backgroundColor: theme.palette.internal.main,
        borderColor: theme.palette.internal.main,
        color: theme.palette.common.white,
      },
      [`&.${stepIconClasses.completed}`]: {
        backgroundColor: theme.palette.internal.main,
        borderColor: theme.palette.internal.main,
        color: theme.palette.internal.main,
      },
    },
    [`& .${linkClasses.root}`]: {
      color: theme.palette.internal.main,
    },
  }),
}));

const Step = forwardRef<HTMLDivElement, StepProps>(({ color = 'primary', ...props }, ref) => (
  <StyledMuiStep color={color} {...props} ref={ref} />
));

Step.displayName = 'Step';

export default Step;
